import React from "react";
import { Checkbox, Dropdown, Form } from "semantic-ui-react";
import useComplianceSummaryFilters from "@hooks/useComplianceSummaryFilters";
import useComplianceView from "@hooks/useComplianceView";

const TypesFilterItem = ({ id, prefix, name, checked, onClick, disabled }) => {
  const onToggle = (e) => {
    e.stopPropagation();
    e.preventDefault();
    onClick(id);
  };

  return (
    <Dropdown.Item onClick={onToggle} className="p-0" disabled={disabled}>
      <Checkbox
        checked={checked}
        disabled
        className="p-0 clickable"
        style={{ position: "relative", top: "4px", marginRight: "0.3em" }}
      />{" "}
      {prefix ? `${prefix} - ${name}` : name}
    </Dropdown.Item>
  );
};

const TypesFilterDropdown = () => {
  const {
    onEventTypeChange,
    onSelfExclusionTypeChange,
    onIncidentTypeChange,
    selectedEventType,
    selectedIncidentType,
    selectedSelfExclusionType,
    eventTypes,
    incidentTypes,
    selfExclusionTypes,
  } = useComplianceSummaryFilters();
  const { isLoading, hasSelection, filters, setViewData } = useComplianceView();
  const maximumSelected =
    selfExclusionTypes.length + eventTypes.length + incidentTypes.length - 2;
  const totalSelected =
    selectedSelfExclusionType.length +
    selectedEventType.length +
    selectedIncidentType.length;
  const allSelected = maximumSelected <= totalSelected;

  const onSelectAll = (e) => {
    e.stopPropagation();
    e.preventDefault();

    const payload = allSelected
      ? {
          filters: {
            ...filters,
            selectedEventType: [],
            selectedIncidentType: [],
            selectedSelfExclusionType: [],
          },
        }
      : {
          filters: {
            ...filters,
            selectedEventType: [
              ...eventTypes
                .filter((x) => ![3, 5].includes(x.id))
                .map((x) => x.id),
            ],
            selectedIncidentType: [...incidentTypes.map((x) => x.id)],
            selectedSelfExclusionType: [...selfExclusionTypes.map((x) => x.id)],
          },
        };
    setViewData(payload);
  };

  return (
    <Form.Field width={5}>
      <label>Event Types:</label>
      <Dropdown
        text={allSelected ? "All selected" : `${totalSelected} selected`}
        selection
        disabled={!hasSelection || isLoading}
      >
        <Dropdown.Menu>
          <Dropdown.Item onClick={onSelectAll}>
            <Checkbox
              disabled
              style={{ position: "relative", top: "4px", marginRight: "0.3em" }}
              checked={allSelected}
            />{" "}
            <small>SELECT ALL</small>
          </Dropdown.Item>
          <Dropdown.Divider />
          {eventTypes
            .filter((x) => ![3, 5].includes(x.id))
            .map((eventType, index) => (
              <TypesFilterItem
                {...eventType}
                onClick={onEventTypeChange}
                key={index}
                checked={selectedEventType.includes(eventType.id)}
              />
            ))}
          <Dropdown.Divider />
          {incidentTypes.map((incidentType, index) => (
            <TypesFilterItem
              prefix="Incident"
              {...incidentType}
              onClick={onIncidentTypeChange}
              key={index}
              checked={selectedIncidentType.includes(incidentType.id)}
            />
          ))}
          {selfExclusionTypes.map((selfExclusionType, index) => (
            <TypesFilterItem
              prefix="Incident"
              {...selfExclusionType}
              onClick={onSelfExclusionTypeChange}
              key={index}
              checked={selectedSelfExclusionType.includes(selfExclusionType.id)}
            />
          ))}
        </Dropdown.Menu>
      </Dropdown>
    </Form.Field>
  );
};

export default TypesFilterDropdown;
